/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y4ti1b66%7Bpadding-inline-end%3Avar(--ds-space-050%2C4px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syazazsu%7Bcolor%3Avar(--ds-text-subtle%2C%23505258)%7D");
import React, { type ReactNode } from 'react';
import Anchor from '@atlaskit/primitives/anchor';
import Box from '@atlaskit/primitives/box';
import { Box as CompiledBox } from '@atlaskit/primitives/compiled';
import Inline from '@atlaskit/primitives/inline';
import Pressable from '@atlaskit/primitives/pressable';
import Stack from '@atlaskit/primitives/stack';
import Text from '@atlaskit/primitives/text';
// eslint-disable-next-line @townsquare/rules/no-xcss
import { xcss } from '@atlaskit/primitives/xcss';
import { AgentAvatar } from '@atlaskit/rovo-agent-components';
import { AgentCreatedBy, useAgentUrlActions, useRecommendedAgents } from '@atlassian/conversation-assistant-agent';
import { useAtlasURL } from '@atlassian/conversation-assistant-agent/controllers/atlas-url';
import { FormattedMessage } from 'react-intl';
import { useAnalytics } from '@townsquare/analytics';
import { fg } from '@townsquare/stat-sig/gate';
type AgentType = ReturnType<typeof useRecommendedAgents>['recommendedAgents'][number];
const cardStyles = xcss({
  borderWidth: 'border.width',
  borderStyle: 'solid',
  borderColor: 'color.border',
  borderRadius: 'radius.large',
  padding: 'space.200',
  cursor: 'pointer',
  transitionProperty: 'background-color',
  transitionDuration: '0.25s',
  transitionTimingFunction: 'ease-in-out',
  ':hover': {
    backgroundColor: 'color.background.neutral.subtle.hovered'
  },
  textAlign: 'left',
  position: 'relative'
});
const pressableStyles = xcss({
  position: 'absolute',
  inset: 'space.0',
  borderRadius: 'radius.large',
  zIndex: 'card'
});
const anchorOverlayStyles = xcss({
  position: 'absolute',
  inset: 'space.0',
  borderRadius: 'radius.large',
  zIndex: 'card'
});
const agentAuthorStyles = xcss({
  zIndex: 'card',
  display: 'flex',
  alignItems: 'center'
});
const createdByStyles = xcss({
  color: 'color.text.subtle',
  paddingInlineEnd: 'space.050'
});
const compiledCreatedByStyles = {
  root: "_syazazsu _y4ti1b66"
};
export function Agent({
  siteId,
  ...agent
}: {
  siteId: string;
} & AgentType): React.JSX.Element {
  const analytics = useAnalytics();
  const {
    onViewAgentFullProfile
  } = useAgentUrlActions({
    siteId
  });
  const {
    atlasURL
  } = useAtlasURL(siteId);
  const viewAgent = () => {
    void analytics.ui('browseAgentCard', 'clicked', {
      agentId: agent.id
    });
    onViewAgentFullProfile(agent.id);
  };
  const authorOnClick = () => {
    void analytics.ui('link', 'clicked', {
      agentId: agent.id
    }, 'browseAgentsCreatorLink');
  };
  return <Box testId={`agent-browse-card-${agent.id}`} xcss={cardStyles}>
			{fg('teams-a11y-35570-35519-35450') ? <Anchor xcss={anchorOverlayStyles} href={atlasURL(`/people/agent/${agent.id}`)} target="_blank" onClick={() => void analytics.ui('browseAgentCard', 'clicked', {
      agentId: agent.id
    })} testId={`agent-browse-card-${agent.id}-clickable`} /> : <Pressable xcss={pressableStyles}
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
    style={{
      backgroundColor: 'transparent'
    }} onClick={viewAgent} testId={`agent-browse-card-${agent.id}-clickable`} />}
			<Stack grow="fill" space="space.200" spread="space-between">
				<Inline space="space.100" alignInline="start" alignBlock="center">
					<AgentAvatar agentNamedId={agent.external_config_reference ?? agent.named_id} agentId={agent.id} agentIdentityAccountId={agent.identity_account_id} size="medium" isForgeAgent={agent.creator_type === 'FORGE'} forgeAgentIconUrl={agent.icon} />
					<Stack>
						<Text weight="bold">{agent.name}</Text>
						{fg('teams-a11y-35570-35519-35450') ? <Box xcss={agentAuthorStyles}>
								<FormattedMessage id="townsquare.views.directory.browse-agent-card-created-by" description="Label to indicate the creator of the agent" defaultMessage="<text>by</text> {creatorName}" values={{
              text: (chunks: ReactNode[]) => fg('townsquare-compiled-xcss-to-cssmap') ? <CompiledBox xcss={compiledCreatedByStyles.root}>{chunks}</CompiledBox> : <Box xcss={createdByStyles}>{chunks}</Box>,
              creatorName: <AgentCreatedBy agent={agent} siteId={siteId} simplified />
            }} />
							</Box> : <>
								{/* eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable */}
								<Box xcss={agentAuthorStyles} onClick={authorOnClick}>
									<FormattedMessage id="townsquare.views.directory.browse-agent-card-created-by" description="Label to indicate the creator of the agent" defaultMessage="<text>by</text> {creatorName}" values={{
                text: (chunks: ReactNode[]) => fg('townsquare-compiled-xcss-to-cssmap') ? <CompiledBox xcss={compiledCreatedByStyles.root}>{chunks}</CompiledBox> : <Box xcss={createdByStyles}>{chunks}</Box>,
                creatorName: <AgentCreatedBy agent={agent} siteId={siteId} simplified />
              }} />
								</Box>
							</>}
					</Stack>
				</Inline>
				<Text color="color.text.subtle" maxLines={2}>
					{agent.description}
				</Text>
			</Stack>
		</Box>;
}